<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14gctdt/tc-custom/9781646563265.jpg?1693541886259" alt="This image is the cover for the book Late Night Poetry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Late Night Poetry
      </h1>
      <p class="bookDescription body article font2">
        <p>A love story told in answering machine messages.<br/><br/>Saying “I love you” to someone who says it first, isn’t supposed to lead to a break-up, but that’s what happens to Sully and Lou. Sully is out and proud while Lou is in the closet, so when their relationship deepens, Lou runs.<br/><br/>But then Lou starts leaving emotional messages of remorse on Sully’s answering machine. Sully is torn between his love for Lou and his attempts to get over him. With each message, Lou’s regrets deepen. With each message, it becomes more difficult for Sully to forget him. With each message, Sully finds it harder to want to move on.<br/><br/>Can old love poems and heartbreaking honesty help Sully and Lou find their way back to each other?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nell Iris
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f1ba542